module.exports = __webpack_public_path__ + "static/media/przemiana3_right.17b57c6d.jpeg";